import React from "react";

// footer imports
import linkedinLogo from "../../assetFiles/LI-Logo.png"
import gmailLogo from "../../assetFiles/gmailLogo.png"
import githubLogo from "../../assetFiles/GitHub_Logo.png"

function SkillsPage() {
    return (
        <>
            <div style={{ display: 'flex', width: '100vw', height: '100vh', overflow: 'hidden'}}>
                <div style={{
                    position: 'fixed',
                    top: '30px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '95%',
                    zIndex: 2,
                }}>
                    <div style={{
                        backgroundColor: 'rgba(0, 0, 0, 0.9)',
                        border: '2px solid #333',
                        borderRadius: '15px',
                        padding: '10px',
                        boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                        display: 'flex',
                        justifyContent: 'space-around',
                        alignItems: 'center'
                    }}>
                        <a href="/Home" style={{ color: 'white', textDecoration: 'none' }}>Home</a>
                        <a href="/Education" style={{ color: 'white', textDecoration: 'none' }}>Education</a>
                        <a href="/Experience" style={{ color: 'white', textDecoration: 'none' }}>Experience</a>
                        <a href="/Leadership" style={{ color: 'white', textDecoration: 'none' }}>Leadership</a>
                        <a href="/Projects" style={{ color: 'white', textDecoration: 'none' }}>Projects</a>
                        <a href="/Skills" style={{ color: 'white', textDecoration: 'none' }}>Skills</a>
                    </div>
                </div>
                <div style={{ width: '50%', height: '100%', position: 'relative', backgroundColor: '#131313', justifyContent: 'center'}}>
                    <div style={{
                        position: 'relative',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 1,
                        width: '505px',
                        maxHeight: '60%',
                        overflow: 'auto',
                        marginBottom: '2rem'
                    }}>
                        <div style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.9)',
                            border: '2px solid #333',
                            borderRadius: '15px',
                            padding: '15px',
                            boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                            marginTop: '43px',
                            marginLeft: '70px',
                            color: 'white'
                        }}>
                            <h2 style={{textAlign: 'left'}}>Technical Development</h2>
                            <h5 style={{textAlign: 'left'}}>(You may have to scroll to see all)</h5>
                            <div style={{width: '100%', height: '1px', backgroundColor: 'white', marginBottom: '10px'}}></div>
                            <div style={{display: 'flex', alignItems: 'flex-start'}}>
                                <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                                    <span style={{fontSize: '1em', textAlign: 'flex-start', fontWeight: 'bold', marginBottom: '10px'}}>Languages:</span>
                                    <span style={{marginBottom: '5px'}}>Python</span>
                                    <span style={{marginBottom: '5px'}}>Java</span>
                                    <span style={{marginBottom: '5px'}}>JavaScript</span>
                                    <span style={{marginBottom: '5px'}}>HTML</span>
                                    <span style={{marginBottom: '5px'}}>CSS</span>
                                    <span style={{marginBottom: '5px'}}>R</span>
                                    <span style={{marginBottom: '5px'}}>C</span>
                                </div>
                            </div>
                            <div style={{width: '100%', height: '1px', backgroundColor: 'white', marginBottom: '10px'}}></div>
                            <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '10px'}}>
                                <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                                    <span style={{fontSize: '1em', textAlign: 'flex-start', fontWeight: 'bold', marginBottom: '10px'}}>Libraries and Software</span>
                                    <span style={{marginBottom: '5px'}}>React.js</span>
                                    <span style={{marginBottom: '5px'}}>Flask</span>
                                    <span style={{marginBottom: '5px'}}>Matplotlib</span>
                                    <span style={{marginBottom: '5px'}}>Pillow</span>
                                    <span style={{marginBottom: '5px'}}>Numpy</span>
                                    <span style={{marginBottom: '5px'}}>PyMySQL</span>
                                    <span style={{marginBottom: '5px'}}>Visual Studio Code</span>
                                    <span style={{marginBottom: '5px'}}>Jupyter Notebook</span>
                                    <span style={{marginBottom: '5px'}}>DataGrip</span>
                                    <span style={{marginBottom: '5px'}}>PyCharm</span>
                                    <span style={{marginBottom: '5px'}}>IntelliJ IDEA</span>
                                    <span>Codio</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* other side */}
                <div style={{ 
                        width: '50%', 
                        height: '100%', 
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '20px',
                        background: '#131313',
                    }}>
                    <div style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.9)',
                            border: '2px solid #333',
                            borderRadius: '15px',
                            padding: '15px',
                            boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                            marginLeft:'70px',
                            color: 'white',
                            width: '400px'
                        }}>
                            <h2 style={{textAlign: 'left'}}>Managerial Knowledge</h2>
                            <div style={{width: '100%', height: '1px', backgroundColor: 'white', marginBottom: '10px'}}></div>
                            <div style={{display: 'flex', alignItems: 'flex-start'}}>
                                <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                                    <span style={{fontSize: '1em', textAlign: 'flex-start', fontWeight: 'bold', marginBottom: '10px'}}>Software:</span>
                                    <span style={{marginBottom: '5px'}}>JIRA</span>
                                    <span style={{marginBottom: '5px'}}>Confluence</span>
                                    <span style={{marginBottom: '5px'}}>Smartsheet</span>
                                </div>
                            </div>
                            <div style={{width: '100%', height: '1px', backgroundColor: 'white', marginBottom: '10px'}}></div>
                            <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '10px'}}>
                                <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                                    <span style={{fontSize: '1em', textAlign: 'flex-start', fontWeight: 'bold', marginBottom: '10px'}}>Methodologies and Frameworks</span>
                                    <span style={{marginBottom: '5px'}}>Agile Scrum</span>
                                    <span style={{marginBottom: '5px'}}>Agile Kanban</span>
                                    <span style={{marginBottom: '5px'}}>SAFe Agile</span>
                                    <span>Software Development Life Cycle</span>
                                </div>
                            </div>
                    </div>
                </div>  
                    <div style={{
                            position: 'absolute',
                            bottom: '10px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: '95%',
                            zIndex: 2,
                            transition: 'opacity 1s ease-in'
                        }}>
                        <div style={{
                                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                                border: '2px solid #333',
                                borderRadius: '15px',
                                padding: '10px',
                                boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}>
                            <span style={{ color: 'white' }}>© 2024 Steven Huang | Product Manager & Developer | v1.2 | stevenhuangtech@gmail.com</span>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center'  // This ensures vertical centering of the buttons
                                }}>
                                <span style={{ color: 'white'}}>Interested? Feel free to contact me! ---{'>'} </span>
                                <a 
                                    href="mailto:stevenhuangtech@gmail.com" 
                                    style={{
                                    backgroundColor: 'white',
                                    border: 'none',
                                    padding: '5px',
                                    margin: '0 5px',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '20px',
                                    height: '20px',
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.opacity = 0.7}
                                    onMouseLeave={(e) => e.currentTarget.style.opacity = 1}
                                    >
                                    <img 
                                        src={gmailLogo}
                                        alt="Email"
                                        style={{
                                            width: '20px',
                                            height: '20px'
                                        }}
                                    />
                                </a>
                                <a 
                                    href="https://github.com/huangs-nyc" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    style={{
                                    backgroundColor: 'white',
                                    border: 'none',
                                    padding: '5px',
                                    margin: '0 5px',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '70px',
                                    height: '20px'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.opacity = 0.9}
                                    onMouseLeave={(e) => e.currentTarget.style.opacity = 1}
                                    >
                                    <img 
                                        src={githubLogo} 
                                        alt="Github"
                                        style={{
                                        width: '50px',
                                        height: '20px'
                                        }}
                                    />
                                </a>
                                <a 
                                    href="https://www.linkedin.com/in/steven-huang-a60a8a22a/" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    style={{
                                    backgroundColor: 'white',
                                    border: 'none',
                                    padding: '5px',
                                    margin: '0 5px',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100px',
                                    height: '20px'
                                }}
                                    onMouseEnter={(e) => e.currentTarget.style.opacity = 0.9}
                                    onMouseLeave={(e) => e.currentTarget.style.opacity = 1}
                                >
                                <img 
                                    src={linkedinLogo} 
                                    alt="LinkedIn"
                                    style={{
                                    width: '80px',
                                    height: '20px'
                                    }}
                                />
                                </a>
                            </div>
                        </div>
                </div>
            </div>
        </>
    )
}

export default SkillsPage